
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.673 24.864c-1.776 0-3.473-1.083-4.047-2.833l-.039-.132a4.316 4.316 0 01-.192-1.244v-7.82l-3.28 9.27c-.346 1.366.408 3.32 1.731 3.698l17.864 4.675c.215.058.429.085.64.085a2.488 2.488 0 002.398-1.875l.702-3.824H12.673z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M17.492 13.55a2.237 2.237 0 002.235-2.235 2.237 2.237 0 00-2.235-2.235 2.237 2.237 0 00-2.234 2.235 2.237 2.237 0 002.235 2.235z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M29.215 5.729H13.442a2.797 2.797 0 00-2.794 2.793V19.79a2.797 2.797 0 002.794 2.793h15.773a2.797 2.797 0 002.793-2.793V8.522a2.797 2.797 0 00-2.793-2.793zM13.442 7.963h15.773c.308 0 .558.25.558.56v7.93l-2.683-4.205c-.374-.439-.916-.674-1.498-.687a1.952 1.952 0 00-1.493.705l-4.15 4.98-1.352-1.348a1.961 1.961 0 00-2.77 0l-2.944 3.262V8.522c0-.309.25-.559.559-.559z","fill":"#525F7F"}})])
          )
        }
      }
    